export default __webpack_public_path__ + "static/media/10.a2c408f8.png";